<template>
  <vue-modal id="reservationModal"
             classes="vue-modal-container"
             height="auto"
             name="reservation-modal">
    <div class="header">
      <h3>Foglalásaim</h3>
      <button class="close-modal"
              @click="$modal.hide('reservation-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <div v-if="hasReservation">
        <table class="ui celled table">
          <thead>
          <tr>
            <th>Állapot</th>
            <th>Pálya</th>
            <th>Időpont</th>
            <th>Partner</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="reservation in filteredUserReservations">
            <td>{{ getStatusText(reservation.status) }}</td>
            <td>{{ reservation.subject.typeName }}: {{ reservation.subject.name }}</td>
            <td>{{ getFormattedDate(reservation.time.start, reservation.time.end) }}</td>
            <td>{{ reservation.client.name }}</td>
          </tr>
          </tbody>
        </table>
        <div v-if="paginationPageCount > 1">
          <div class="ui pagination menu">
            <a v-for="n in paginationPageCount"
               :class="{'active': currentPaginationPage === n}"
               class="item"
               @click="setPaginationPage(n)">
              {{ n }}
            </a>
          </div>
        </div>
      </div>
      <div v-else>
        Még nincs foglalása
      </div>
    </div>
  </vue-modal>
</template>

<script>
import moment from 'moment'

export default {
  // props: ['userReservations'],
  data () {
    return {
      paginationItemPerPage: 10,
      currentPaginationPage: 1,
      paginationPageCount: 1,
    }
  },
  methods: {
    getFormattedDate (start, end) {
      return '' + moment(start).format('YYYY-MM-DD H:mm') + ' - ' + moment(end).format('H:mm')
    },
    getStatusText (status) {
      let statusTranslatle = {
        reserved: 'Lefoglalt',
        missed: 'Mulasztott',
        attended: 'Megjelent',
      }
      if (statusTranslatle?.status?.toLowerCase()) {
        return statusTranslatle[status]
      }
      return status
    },
    setPaginationPage (newPageNumber) {
      this.currentPaginationPage = newPageNumber
    },
  },
  computed: {
    hasReservation () {
      return this.userReservations.length > 0
    },
    userReservations () {
      const itemPerPage = this.paginationItemPerPage
      let result = this.$store.state.userReservations
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.paginationPageCount = Math.ceil(result.length / itemPerPage)
      return result
    },
    filteredUserReservations () {
      /* eslint-disable */
      const itemPerPage = this.paginationItemPerPage
      let userReservations = this.userReservations
      let currentPaginationPage = this.currentPaginationPage
      let result = []
      result = userReservations.slice((currentPaginationPage - 1) * itemPerPage, currentPaginationPage * itemPerPage)

      return result
    },
  },
}
</script>
